export default __webpack_public_path__ + "static/media/ic_info.1fd66a4f.svg";